<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds">
    <div class="content flex">
      <div class="govuk-breadcrumbs">
        <ol class="govuk-breadcrumbs__list">
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/home">{{ 'REGITERATION_HOME' | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register">{{ 'CREATE_ACC' | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/initial-search">{{ 'ENTER_DETAIL' |
              translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/initial-search-status/new">{{ 'REG_ORG'
              | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/newreg">{{ 'ORG_ADMIN' | translate
              }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item" *ngIf="isCustomMfaEnabled">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-reg-organisation-mfa">{{ '2FA_SETUP' | translate }}</a>
        </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/type">{{ 'ORG_TYPE' | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item" *ngIf="buyerFlow == 3">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/buyer-type">{{ 'BUYER_TYPE_BC' |
              translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/search">{{ 'ORG_DETAILS' | translate
              }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <a class="govuk-breadcrumbs__link" href="javascript:;" (click)="goConfirmOrgPage()">{{ 'CONFIRM_ORG_DETAILS'
              | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item" *ngIf="pageAccessMode == 0">
            <a class="govuk-breadcrumbs__link" routerLink="/manage-org/register/error/wrong-details">{{
              'WRONG_ORG_DETAILS' | translate }}</a>
          </li>
          <li class="govuk-breadcrumbs__list-item" *ngIf="pageAccessMode == 2">
            <a class="govuk-breadcrumbs__link" href="javascript:;" (click)="goBack()">{{ 'ADD_REG' | translate }}</a>
          </li>

          <li class="govuk-breadcrumbs__list-item">
            <span class="govuk-breadcrumbs__link"> {{ 'CREATE_ADMIN_ACC' | translate }}</span>
          </li>
        </ol>
      </div>
      <h1 class="govuk-heading-xl page-title">Create your administrator account</h1>
      <p class="govuk-body-l">As you are the first person registering the organisation, you will be the administrator
        for your organisation’s account</p>
      <p style="padding-top:10px;">Alternatively, you can <a id="nominateLink" class="navigation-text"
          (click)="onClickNominate()">nominate a colleague to register and
          become an administrator</a></p>
      <br>
      <div class="govuk-grid-row">
        <div class="govuk-grid-column-three-quarters">
          <form class="govuk-!-width-three-quarters" [class.error]="!formValid(formGroup)" [formGroup]="formGroup">
            <div class="govuk-form-group" *ngIf="formValid(formGroup) == false && submitted">
              <div class="govuk-error-summary govuk-grid-column-three-quarters" aria-labelledby="error-summary-title" id="error-summary"
                role="alert" tabindex="-1" data-module="govuk-error-summary">
                <h2 class="govuk-error-summary__title" id="error-summary-title"> There is a problem</h2>
                <div class="govuk-error-summary__body">
                  <ul class="govuk-list govuk-error-summary__list">
                    <a onClick="return false;" (click)="setFocus(0)" href="javascript:;"
                      *ngIf="formGroup.controls['firstName'].hasError('required')">
                      <li>Enter your first name</li>
                    </a>
                    <a onClick="return false;" (click)="setFocus(1)" href="javascript:;"
                      *ngIf="formGroup.controls['lastName'].hasError('required')">
                      <li>Enter your last name</li>
                    </a>
                    <a onClick="return false;" (click)="setFocus(2)" href="javascript:;"
                      *ngIf="formGroup.controls['email'].hasError('required')">
                      <li>Enter your work email address</li>
                    </a>
                    <a onClick="return false;" (click)="setFocus(2)" href="javascript:;"
                      *ngIf="submitted && !formGroup.controls.email.errors?.required && formGroup.controls.email.invalid">
                      <li>Enter an email address in the correct format, like name&#64;example.com</li>
                    </a>
                    <a *ngIf="submitted && ((!formGroup.controls.lastName.errors?.required && formGroup.controls.lastName.invalid) || (!formGroup.controls.firstName.errors?.required && formGroup.controls.firstName.invalid))"
                      href="javascript:;" onClick="return false;" (click)="customFocum()">
                      <li>{{ 'ENTER_NAME_WITHOUT_NUM_SPECIAL' | translate }}</li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
            <!-- <div class="govuk-form-group"
              [class.govuk-form-group--error]="submitted && formGroup.controls.title.invalid" [hidden]="true">
              <label class="govuk-label" for="title">Title</label>
              <span id="title-error" class="govuk-error-message" *ngIf="submitted && formGroup.controls.title.invalid">
                <span class="govuk-visually-hidden">Error:</span>Select your title
              </span>
              <select class="govuk-select" id="title" name="title" formControlName="title"
                [class.govuk-select--error]="submitted && formGroup.controls.title.invalid">
                <option *ngFor="let item of userTitleEnum | enumToArray" [ngValue]="item">{{
                  userTitleEnum[item] }}</option>
              </select>
            </div> -->
            <div class="govuk-form-group">
              <label class="govuk-label" for="organisation">{{ 'NAME_OF_YOUR_ORGANISATION' | translate }}</label>
              <input [readonly]="true" [class.disabled]="true" class="govuk-input text-box-disabled" id="organisation"
                name="organisation" maxlength="100" spellcheck="false"
                [value]="ciiOrganisationInfo.identifier?.legalName">
            </div>
            <div class="govuk-form-group"
              [class.govuk-form-group--error]="submitted && formGroup.controls.firstName.invalid">
              <label class="govuk-label" for="firstName">{{ 'FIRSTNAME' | translate }}</label>
              <span id="firstname-error" class="govuk-error-message"
                *ngIf="submitted && formGroup.controls.firstName.errors?.required">
                <span class="govuk-visually-hidden">Error:</span>Enter your first name
              </span>
              <span id="firstname-error" class="govuk-error-message"
                *ngIf="submitted && !formGroup.controls.firstName.errors?.required && formGroup.controls.firstName.invalid">
                <span class="govuk-visually-hidden">Error:</span>{{ 'ENTER_NAME_WITHOUT_NUM_SPECIAL' | translate }}
              </span>
              <input #input class="govuk-input" id="firstName" formControlName="firstName" maxlength="100"
                name="firstName" size="20" type="text" value="" autocomplete="given-name"
                [class.govuk-input--error]="submitted && formGroup.controls.firstName.invalid">
            </div>
            <div class="govuk-form-group"
              [class.govuk-form-group--error]="submitted && formGroup.controls.lastName.invalid">
              <label class="govuk-label" for="lastName">{{ 'LASTNAME' | translate }}</label>
              <span id="lastname-error" class="govuk-error-message"
                *ngIf="submitted && formGroup.controls.lastName.errors?.required">
                <span class="govuk-visually-hidden">Error:</span>Enter your last name
              </span>
              <span id="lastname-error" class="govuk-error-message"
                *ngIf="submitted && !formGroup.controls.lastName.errors?.required && formGroup.controls.lastName.invalid">
                <span class="govuk-visually-hidden">Error:</span>{{ 'ENTER_NAME_WITHOUT_NUM_SPECIAL' | translate }}
              </span>
              <input #input class="govuk-input" id="lastName" formControlName="lastName" maxlength="100" name="lastName"
                size="20" type="text" value="" autocomplete="family-name"
                [class.govuk-input--error]="submitted && formGroup.controls.lastName.invalid">
            </div>
            <div class="govuk-form-group"
              [class.govuk-form-group--error]="submitted && formGroup.controls.email.invalid">
              <label class="govuk-label" for="email">{{ 'WORK_EMAIL_ADDRESS' | translate }}</label>
              <span id="email-error" class="govuk-error-message"
                *ngIf="submitted && formGroup.controls.email.errors?.required">
                <span class="govuk-visually-hidden">Error:</span>Enter your work email address
              </span>
              <span id="email-error" class="govuk-error-message"
                *ngIf="submitted && !formGroup.controls.email.errors?.required && formGroup.controls.email.invalid">
                <span class="govuk-visually-hidden">Error:</span>Enter an email address in the correct format, like
                name&#64;example.com
              </span>
              <input #input class="govuk-input" id="email" formControlName="email" name="email" size="20" type="text"
                value="" autocomplete="email" type="email" value="" autocomplete="email" spellcheck="false"
                (input)="validateEmailLength($event)"
                [class.govuk-input--error]="submitted && formGroup.controls.email.invalid">
            </div>
            <div class="govuk-form-group">
              <button id="continueButton" type="submit" class="govuk-button" data-module="govuk-button"
                (click)="onSubmit(formGroup)">Continue</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>